export const LIST_COLORS = [
  { id: "klein", label: "Klein", bg: "#002FA7", text: "#fff" },
  { id: "signal", label: "Signal", bg: "#FF2A2A", text: "#fff" },
  { id: "canary", label: "Canary", bg: "#FFD700", text: "#000" },
  { id: "bubble", label: "Bubble", bg: "#FF6BEB", text: "#000" },
  { id: "leaf", label: "Leaf", bg: "#00C853", text: "#fff" },
  { id: "sky", label: "Sky", bg: "#7DD3FC", text: "#000" },
  { id: "orange", label: "Orange", bg: "#FB923C", text: "#000" },
  { id: "lavender", label: "Lavender", bg: "#C4B5FD", text: "#000" },
  { id: "graphite", label: "Graphite", bg: "#000000", text: "#fff" },
  { id: "mist", label: "Mist", bg: "#E5E5E5", text: "#000" },
];

export function listColorStyle(colorId) {
  if (!colorId) return { background: "#F0F0F0", color: "#000" };
  const c = LIST_COLORS.find((x) => x.id === colorId);
  if (!c) return { background: "#F0F0F0", color: "#000" };
  return { background: c.bg, color: c.text };
}

export const LABEL_PALETTE = [
  "#FF2A2A", "#FB923C", "#FFD700", "#00C853", "#06B6D4",
  "#002FA7", "#7C3AED", "#FF6BEB", "#000000", "#64748B",
];
